import React from 'react';
import {
  Grid,
  Icon,
  Icons,
  Stack,
  Typography,
} from '@nextiva/next-ui-components';
import { RegistrationNotStartedProps } from 'interface/WizardV3';
import { ButtonStyled } from '../MessagingNew.styled';
import { Subtitle3Typo } from '../CampaignDialog/WizardV3.styled';

const estimatedTime = 'This should only take few minutes.';
const startRegistration = 'Start registration';
const dataTestId = 'PlatformAdminUI-Messaging-RegistrationNotStarted';
export function RegistrationNotStarted({
  handleOpenComplianceFeesDialog,
  showAutom8tly,
}: RegistrationNotStartedProps) {
  return (
    <Grid
      container
      columnSpacing={3}
      alignItems="center"
      data-testid={dataTestId}
    >
      <Grid item>
        <ButtonStyled
          color="primary"
          variant="contained"
          onClick={handleOpenComplianceFeesDialog}
          data-testid={`${dataTestId}-StartButton`}
        >
          {startRegistration}
        </ButtonStyled>
      </Grid>
      {!showAutom8tly && (
        <Grid item alignItems="center">
          <Subtitle3Typo
            data-testid={`${dataTestId}-RegistryTimeText`}
            marginLeft="8px"
          >
            {estimatedTime}
          </Subtitle3Typo>
        </Grid>
      )}
      {showAutom8tly && (
        <Grid item alignItems="center">
          <Stack spacing={0.5} direction="row" alignItems="center">
            <Icon size={16} icon={Icons.contactsSolid} />
            <Typography
              variant="body2"
              data-testid={`${dataTestId}-Autom8tlyText`}
              fontWeight={800}
              color="#0B1029"
            >
              AI powered assistance is available now.
            </Typography>
          </Stack>
          <Typography
            variant="body2"
            data-testid={`${dataTestId}-Autom8tlySubText`}
            color="#616576"
          >
            Complete your business messaging registration in minutes.
          </Typography>
        </Grid>
      )}
    </Grid>
  );
}
